// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.app-main[data-v-9fb3baf6] {\n  /*50 = navbar  */\n  min-height: 100vh;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.fixed-header+.app-main[data-v-9fb3baf6] {\n  padding-top: 50px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
